// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"51fb6bed","455":"f0322e66","482":"eac7620b","544":"9d684d2d","550":"c143cd8d","708":"20bcb37a"}[chunkId] + ".chunk.js";
};